<template>
  <div id="welcome">
	<Games @navigate="navigateTo($event)"/>
  </div>
</template>

<script>
import Games from './Games.vue'

export default {
  name: 'Welcome',
  methods: {
    navigateTo(componentName) {
      this.$emit("navigate", componentName);
    },
  },
  components: {
    Games,
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
#welcome {
  font-size: 25px;
}
</style>